const inputName = "recaptcha"

export async function verifyRecaptcha(form) {
  if (!form || typeof form.checkValidity !== 'function' || !form.checkValidity()) {
    // eslint-disable-next-line no-undef
    return Promise.resolve(false)
  }

  const formId = form.id ? form.id.replace(/-/g, "_") : "form"
  const inputToken = form.querySelector(`input[name=${inputName}]`)

  if (!inputToken) {
    // eslint-disable-next-line no-undef
    return Promise.resolve(false)
  }

  const siteKey = inputToken.dataset.key

  // eslint-disable-next-line no-undef
  return new Promise((resolve) => {
    grecaptcha.ready(() => {
      grecaptcha
        .execute(siteKey, {
          action: formId,
        })
        .then((token) => {
          inputToken.value = token
          resolve()
        })
        .catch((e) => {
          console.warn(e)
        })
    })
  })
}